<template>
    <v-container grid-list-md fluid>        
        <div class="mar10 pad20 white-background">

            <v-layout row wrap>
                <v-flex xs12 sm10 md10 lg10 class="float-left">
                    <h2 class="success--text text-right float-left">Recommended Reading</h2>
                </v-flex>
                <v-flex xs12 sm2 md2 lg2 class="float-right"> </v-flex>
            </v-layout> 

            <v-card>
                <!-- Loading -->
                <v-layout row v-if="isLoadingStories == true">
                    <v-flex class="text-xs-center">
                        <v-progress-circular :size="50" indeterminate color="default"></v-progress-circular>
                    </v-flex>
                </v-layout>
                
                <!-- Not Found -->
                <v-layout row v-if="isLoadingStories == false && (!stories || stories.length <= 0)">
                    <v-flex class="text-xs-center">
                        <h4>No stories found!</h4>
                    </v-flex>
                </v-layout>
                
                <!-- Results -->
                <v-flex v-if="stories.length > 0" class="hidden-header">

                    <v-card>
                        <v-card-title class="headline light--cyan-bg" color="light-blue lighten-4" light> </v-card-title>
                    </v-card>
                    
                    <v-data-table :headers="headers" :items="stories" :search="search"  :pagination.sync="pagination" light>

                        <!-- Story List -->
                        <template slot="items" slot-scope="props">  
                            <v-flex xs12 class='card-items'>
                                <v-card>
                                    <v-card-text>
                                        <!-- Story title, image, descriptions -->
                                        <v-layout row wrap>

                                            <v-flex xs12 sm3 md3 lg3 @click="goToStoryDetails(props.item.id)" class="pointer">
                                                <img v-if="props.item.featured_image" class="img-responsive featured-image" :src='props.item.featured_image' v-bind:alt="props.item.photo" >
                                            </v-flex>

                                            <v-flex xs12 sm9 md9 lg9>
                                                <v-layout row wrap>

                                                    <v-flex xs12 sm12 md12 lg12>
                                                        <h1>{{ props.item.title }}  

                                                        </h1>
                                                        <h2>{{ props.item.author }}</h2>
                                                        <h3>{{ props.item.description }}</h3>
                                                        
                                                    </v-flex>
                                            
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>

                                </v-card>
                            </v-flex>
                        </template>

                        <!-- Pagination -->
                        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                        From {{ pageStart }} to {{ pageStop }}
                        </template>

                        <!-- Notifications -->
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                        </v-alert>

                    </v-data-table>
                </v-flex>
            </v-card> 

            <div class="content-body">
                <h1 class="content-title text-center">Share Your Story</h1>
                <div class="text-center bold">Our personal stories support and inspire others. Share your journey with others.</div>
                <div class="text-center">We are creating a library of member submitted stories. When it's ready, you will be able to search and read stories from others here.</div>
                <iframe src="https://services.cognitoforms.com/f/u5vx8UXMRU-V5VTTzNYvcg?id=3" class="position-relative" frameborder="0" scrolling="yes" seamless="seamless" height="646" width="100%"></iframe>
            </div>            

        </div>
    </v-container>
</template>

<script>
    import StoryService from "@/services/db/StoryService.js";
    import CONSTANT from "@/services/Constant.js"; 
    import TableItem from "../table-list-items/table-list-items.vue";

    export default {
        name: "Stories",
        components: {
          "table-item": TableItem,
        },
        data() {
            return {
                title: "Stories",
                search: "",
                pagination: {
                    page: 1,
                    rowsPerPage: -1,
                    totalItems: 0
                },
                headers: [],
                stories: [],
                isLoadingStories: true
            };
        },
        created() {
            this.loadStories();
        },        
        methods: {
            /*
             * Method to load stories
             */
            loadStories() {
                this.isLoadingStories = true;
                var _USER = JSON.parse(this.$store.getters.loginUser);
                StoryService.getStories(
                    _USER.userId,
                    stories => {
                        this.stories = [];
                        this.isLoadingStories = false;
                        if (stories) {
                            stories.forEach(doc => {
                                var _obj = doc.data();
                                _obj["id"] = doc.id;
                                this.stories.push(_obj);
                            });
                        }
                    }
                );
            },
            getStoryDate(){
                return "25 <br /> DEC";
            },
            // goto story page
            gotoStory(id){
                 this.$router.push('/story/'+id);
            },
            //confirmation dialog
            removeConfirmation(id){
                this.dialog = true;  
                this.removeStoryId = id;
            },
            //remove story 
            removeStory(){ 
                StoryService.removeStoryById(this.removeStoryId)
                .then(() => {
                    this.$store.commit("setAlert", {
                        isAlertSuccess: true,
                        message: CONSTANT.MESSAGES.BOOK.REMOVE_SUCCESS 
                    });
                })
                .catch(() => {
                this.$store.commit("setAlert", {
                        isAlertError: true,
                        message: CONSTANT.MESSAGES.BOOK.REMOVE_FAIL
                    });
                });
            },
            /*
            * Method to redirect story details
            */
            goToStoryDetails(id) {
                this.$router.push(
                    "/stories-detail/" + id
                );
            }, 
            /*
            * Method to redirect specific path
            */
            goToPath(path) {
                this.$router.push(path);
            },
        },
        mounted() {
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', 'https://services.cognitoforms.com/scripts/embed.js')
            document.head.appendChild(recaptchaScript)
        },        
    };
</script>
 